// extracted by mini-css-extract-plugin
export default {"container":"LoyaltyJoinError_container","fadeIn":"LoyaltyJoinError_fadeIn","fadeOut":"LoyaltyJoinError_fadeOut"};